import React, { Component } from 'react'

import malletStationLogo from '../svg/malletStation-logo.svg';
import EM1Logo from '../svg/em1-logo.svg';
import PearlLogo from '../svg/pearl-logo.svg';
import KMILogo from '../svg/kmi-logo.svg';

import StatusBar from './StatusBar'

export default class StatusLogos extends Component {

  render() {
    return (
      <div className="status-logos">
        <img className="malletStation-logo" src={malletStationLogo} draggable="false" alt="malletStation EM1"/>
        <img className="em1-logo" src={EM1Logo} draggable="false" alt="malletStation EM1"/>
        <StatusBar message={this.props.message} />
        <img className="pearl-logo" src={PearlLogo} draggable="false" alt="Pearl"/>
        <img className="kmi-logo" src={KMILogo} draggable="false" alt="Keith McMillen Instruments"/>
      </div>
    )
  }
}
